import { Injectable } from "@angular/core";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";

type ToastMessage = {
  message: string;
  title?: string;
  panelClass: string[];
};

@Injectable({
  providedIn: "root",
})
export class ToastService {
  constructor(private snackBar: MatSnackBar) {}

  messageQueue: ToastMessage[] = [];
  isSnackShowing = false;

  horizontalPosition: MatSnackBarHorizontalPosition = "end";
  verticalPosition: MatSnackBarVerticalPosition = "top";

  showSuccess(message: string, title?: string): void {
    this._add({ message, title, panelClass: ["snackbar-success"] });
  }

  showError(message: string, title?: string): void {
    this._add({ message, title, panelClass: ["snackbar-error"] });
  }

  showInfo(message: string, title?: string): void {
    this._add({ message, title, panelClass: ["snackbar-info"] });
  }

  showWarning(message: string, title?: string): void {
    this._add({ message, title, panelClass: ["snackbar-warning"] });
  }

  private _add(message: ToastMessage): void {
    this.messageQueue.push(message);
    if (!this.isSnackShowing) {
      this._showNextMessage();
    }
  }

  private _showNextMessage() {
    if (this.messageQueue.length === 0) {
      this.isSnackShowing = false;
      return;
    }

    this.isSnackShowing = true;
    const nextMessage = this.messageQueue.shift();

    const snackBarRef = this.snackBar.open(
      nextMessage!.title ? `${nextMessage!.title}: ${nextMessage!.message}` : nextMessage!.message,
      "Close",
      {
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
        panelClass: nextMessage!.panelClass,
        duration: 5000,
      }
    );

    snackBarRef.afterDismissed().subscribe(() => {
      this._showNextMessage();
    });
  }
}
